import { jsx as _jsx } from "react/jsx-runtime";
export const SingleColumnCentered = ({ id, testId, children, }) => {
    return (_jsx("div", { id: id, "data-test-id": testId, "data-eco-component": "single-column-center", className: "py-3", children: _jsx("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 md:px-8", children: _jsx("div", { className: "py-3", children: children }) }) }));
};
export default SingleColumnCentered;
